import { createElement } from 'react';

import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import LockIcon from '@mui/icons-material/Lock';

import { rootRouteRef } from './routes';

const secretsSharingPage = PageBlueprint.make({
  name: 'secrets-sharing',
  params: {
    path: '/secrets-sharing',
    title: 'Secrets Sharing',
    icon: createElement(LockIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { SecretsSharing } = await import('./components/SecretsSharing');
      return createElement(SecretsSharing);
    },
  },
});

export const secretsSharingPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'secrets-sharing-frontend',
  extensions: [secretsSharingPage],
  routes: {
    root: rootRouteRef,
  },
});
